import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearCart } from './cartActions';

const useCartCleanup = (): void => {
  const dispatch = useDispatch();
  const { lastUpdated, cart_expiration_minutes } = useSelector((state: any) => state.cart);

  useEffect(() => {
    // console.group('🛒 useCartCleanup Check');
    // console.log('📅 lastUpdated:', lastUpdated);
    // console.log('⏱️ cart_expiration_minutes:', cart_expiration_minutes);

    // Validate data before continuing
    if (
      !lastUpdated ||
      typeof lastUpdated !== 'number' ||
      !cart_expiration_minutes ||
      typeof cart_expiration_minutes !== 'number'
    ) {
      // console.warn('⚠️ Skipping setup: missing or invalid cart data');
      console.groupEnd();
      return;
    }

    const expirationTime = new Date(lastUpdated).getTime() + cart_expiration_minutes * 60000;
    const now = new Date().getTime();
    const delay = expirationTime - now;

    // console.log('🧮 Calculated expirationTime:', new Date(expirationTime).toISOString());
    // console.log('🕒 Current time:', new Date(now).toISOString());
    // console.log('⏳ Delay until expiration:', delay, 'ms');

    if (delay <= 0) {
      // console.log('🧹 Cart already expired. Dispatching clearCart() immediately');
      dispatch(clearCart());
      console.groupEnd();
      return;
    }

    const timer = setTimeout(() => {
      // console.log('🧹 Timer fired. Cart expired. Dispatching clearCart()');
      dispatch(clearCart());
    }, delay);

    console.groupEnd();

    return () => {
      clearTimeout(timer);
      // console.log('🔁 Cleanup previous timeout (cart data changed or component unmounted)');
    };
  }, [lastUpdated, cart_expiration_minutes, dispatch]);
};

export default useCartCleanup;
